import { Injectable } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { NgbdErrorModal } from '../modal/error.modal.component';

@Injectable()
export class ErrorModalService {
  constructor(private modalService: NgbModal) { }

  public open(title: string, message: string, buttonCallback?: () => any, ref?: NgbModalRef): NgbModalRef {
    let lockedWindow: NgbModalRef;

    if (ref) {
      ref.close();
      lockedWindow = ref;
    }

    lockedWindow = this.modalService.open(NgbdErrorModal, { backdropClass: 'error-modal', windowClass: 'error-modal', centered: true });
    lockedWindow.componentInstance.title = title;
    lockedWindow.componentInstance.message = message;
    lockedWindow.componentInstance.buttonCallback = buttonCallback;

    return lockedWindow;
  }
}
